module.exports = __webpack_public_path__ + "img/screening.7e364522.png";